import { POST_BANDI_CSV_EXPORT } from '@package/actions';

const initialState = {
  loading: false,
  loaded: false,
  error: null,
  result: null,
};

function download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute(
    'href',
    'data:text/comma-separated-values;charset=utf-8,' +
      encodeURIComponent(text),
  );
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function exportBandiReducer(state = initialState, action = {}) {
  switch (action.type) {
    case `${POST_BANDI_CSV_EXPORT}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };
    case `${POST_BANDI_CSV_EXPORT}_SUCCESS`:
      download(`export-bandi.csv`, action.result);
    // eslint-disable-next-line no-fallthrough
    case `${POST_BANDI_CSV_EXPORT}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case `${POST_BANDI_CSV_EXPORT}_RESET`:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
